export default __webpack_public_path__ + "static/media/GreenCheck.6a168b2b.svg";